import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ExternalBranchesEntity } from '../../domain/entities/ExternalBranchesEntity'
import type { ExternalBranchAdminListedDtoAdmin } from '@/backend/market/models/ExternalBranchAdminListedDtoAdmin'

export class ExternalBranchesModel extends ExternalBranchesEntity {
  constructor(dataDto: ExternalBranchAdminListedDtoAdmin) {
    super()
    mapEntityProperties<ExternalBranchesModel>(this, dataDto)
  }
}
